import { KANVAS_PUSHER_API_KEY } from "env";
import Pusher from "pusher-js";

export const kanvasPusher = new Pusher(KANVAS_PUSHER_API_KEY, {
  cluster: 'us2',
});